<template>
    <div class="tabs">
        <b-tabs content-class="mt-3">
            <b-tab title="홈" :active="initCategoryIdx === -1" @click="$router.push('/')" ></b-tab>
            <b-tab v-for="(item,index) in categoryList" :key="index" :title="item.name"  @click="test(item.idx)"></b-tab>
        </b-tabs>
    </div>
</template>

<script>
export default {
    name: 'Tabs',
    data(){
        return {
            categoryList: [],
        }
    },
    props: {
        initCategoryIdx: {
            type: Number,
            default: -1
        }
        
    },
    created() {
        this.getCategory();
    },
    mounted(){
    },
    beforeDestroy() {
	},
    methods: {
        getCategory(){ // 카테고리 정보
            var param = 
            {
                // limit : 3
            }
            this.$Axios.post(`${this.host}/infocategory`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                if (res.data.returnCode === 0) {
                    this.categoryList = res.data.list;
                    // console.log(this.categoryList);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getCategoryName(category_idx){
            var name = '';
            this.categoryList.forEach(element =>{
                if(category_idx === element.idx){
                    name = element.name;
                }
            })
            return name;
        },
        test(idx){
            console.log(this.initCategoryIdx);
            console.log(idx);

            this.$router.push('/Category/' + idx)
        }
    },
}

</script>